import { Common, ApiBind } from './common.model';
import { DeliveryControlDrawMethod } from '../constants';
import { DeliverySetDeal } from './delivery-set-deal';

export class DeliveryControl extends Common {

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'design_template_id' })
  designTemplateId: number;

  @ApiBind({ column: 'draw_method' })
  drawMethod: DeliveryControlDrawMethod;

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'ratio' })
  ratio: number;

  @ApiBind({ column: 'upper_limit_ratio' })
  upperLimitRatio: number;

  @ApiBind({ column: 'lower_limit_ratio' })
  lowerLimitRatio: number;

  // 画面表示用
  eCPM: string;

  @ApiBind({ column: 'deals', model: (values) => values.map(value => new DeliverySetDeal(value)) })
  deals: DeliverySetDeal[];

}
